<app-deprecated-modal-form
    #templateModal
    [form]="templateForm"
    (save)="onSave()"
    (cancel)="onCancel()"
    headerText="performance.template-show.editTemplate"
>
    <app-form-template #templateForm [template]="template"></app-form-template>
</app-deprecated-modal-form>

<div class="ui basic segment" [class.loading]="isLoading">
    <app-header [title]="template.name" [back]="true" [contextMenu]="true" contextMenuType="material">
        <button *ngIf="performanceReviewImprovements" mat-menu-item (click)="cloneAndRedirectToTemplate()">
            {{ 'duplicate' | translate }}
        </button>
        <button mat-menu-item (click)="onDelete()">{{ 'delete' | translate }}</button>
    </app-header>

    <div class="ui segment">
        <app-segment-header
            title="performance.template-show.templateDetails"
            (edit)="templateModal.show()"
        ></app-segment-header>
        <form class="ui static form" #form="ngForm">
            <div class="inline field">
                <label>{{ 'performance.template-show.dateCreated' | translate }}</label>
                {{ template.createdAt | appDate: 'mediumDate' }}
            </div>

            <div class="inline field">
                <label>{{ 'performance.template-show.description' | translate }}</label>
                {{ template.description }}
            </div>
        </form>
    </div>

    <div class="ui segment">
        <app-segment-header title="performance.template-show.templateQuestions" (edit)="launch()"></app-segment-header>
        <form class="ui static form" #form="ngForm">
            <div class="inline field">
                <label>{{ 'performance.template-show.questions' | translate }}</label>
                {{ template.jsonData && template.jsonData.length ? template.jsonData.length : 0 }}
            </div>
        </form>
    </div>
</div>

<app-deprecated-confirmation-dialog
    #confirmDelete
    [title]="'performance.template-show.deleteTemplate'"
    [description]="'performance.template-show.deleteTemplateConfirmation'"
    [negative]="true"
>
</app-deprecated-confirmation-dialog>

<app-template-builder
    #templateBuilderComponent
    [(fields)]="template.jsonData"
    [templateName]="template?.name"
    [showBuilderImprovements]="performanceReviewImprovements"
    (autosave)="save()"
></app-template-builder>
